import { Outlet, Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useUIStore } from '@/lib/store/uiStore';
import { UserProfile } from '../sidebar/UserProfile';
import { ArrowLeft, MessageSquare, Menu } from 'lucide-react';
import { Button } from '../ui/button';
import { env } from '@/config/env';

function AdminLayout() {
  const { isSidebarOpen, isMobile, setIsMobile, toggleSidebar } = useUIStore();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [setIsMobile]);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Sidebar */}
      <div
        className={`
          transition-transform duration-300 ease-in-out
          border-r border-gray-200
          ${isMobile ? 'fixed inset-y-0 left-0 z-50 w-full' : 'relative w-64'}
          ${isMobile && !isSidebarOpen && '-translate-x-full'}
        `}
      >
        <div className="h-full flex flex-col bg-card border-r border-gray-200">
          {/* Logo header */}
          <div className="p-2 space-y-4">
            <Link
              to="/chat"
              className="flex items-center gap-2 px-2 py-1 hover:opacity-80 transition-opacity"
            >
              {env.appLogoUrl ? (
                <img
                  src={env.appLogoUrl}
                  alt={env.appName}
                  className="h-8 w-auto object-contain"
                />
              ) : (
                <div className="h-8 w-8 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
                  <MessageSquare className="h-4 w-4 text-white" />
                </div>
              )}
              <h1 className="text-lg font-semibold text-foreground truncate">{env.appName}</h1>
            </Link>
          </div>

          {/* Back to chat link */}
          <div className="px-2 pb-2">
            <Link
              to="/chat"
              className="flex items-center gap-2 px-2 py-2 text-sm text-muted-foreground hover:text-foreground hover:bg-muted rounded-md transition-colors"
            >
              <ArrowLeft className="h-4 w-4 flex-shrink-0" />
              <span>Torna alle chat</span>
            </Link>
          </div>

          {/* Spacer */}
          <div className="flex-1" />

          {/* User profile at the bottom */}
          <UserProfile />
        </div>
      </div>

      {/* Mobile overlay */}
      {isMobile && isSidebarOpen && (
        <div
          className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm z-40"
          onClick={toggleSidebar}
        />
      )}

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Mobile header */}
        {isMobile && (
          <div className="border-b border-gray-200 bg-card p-4 flex items-center shadow-sm">
            <Button
              variant="ghost"
              size="icon"
              onClick={toggleSidebar}
              className="mr-2"
            >
              <Menu className="h-5 w-5" />
            </Button>
            <h1 className="text-lg font-semibold text-foreground">Amministrazione</h1>
          </div>
        )}

        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AdminLayout;
